import {
   ApiResponse,
   createApiRequest,
   getHeaderFromSessionStorage,
   Header,
} from "@/api"
import { API_URL, Endpoints } from "@/constants/endpoints"
import { HttpMethods } from "@/constants/globals"
import { LevelConfigurationItem } from "@/types/levelConfiguration"

export async function requestLevelConfigurations(): Promise<
   ApiResponse<LevelConfigurationItem[]>
> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.LEVELS_CONFIGURATIONS}`,
      HttpMethods.GET,
      null,
      getHeaderFromSessionStorage(Header.FACILITY_ID)
   )
   return response
}

export async function requestCreateLevelConfiguration(
   levelConfiguration: Partial<LevelConfigurationItem>
): Promise<ApiResponse<LevelConfigurationItem>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.LEVELS_CONFIGURATIONS}`,
      HttpMethods.POST,
      levelConfiguration,
      getHeaderFromSessionStorage(Header.FACILITY_ID)
   )
   return response
}

export async function requestUpdateLevelConfiguration(
   levelConfigurationId: string,
   levelConfiguration: Partial<LevelConfigurationItem>
): Promise<ApiResponse<LevelConfigurationItem>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.LEVELS_CONFIGURATIONS}${levelConfigurationId}/`,
      HttpMethods.PATCH,
      levelConfiguration,
      getHeaderFromSessionStorage(Header.FACILITY_ID)
   )
   return response
}

export async function requestUpdateLevelConfigurations(
   levelConfigurations: Partial<LevelConfigurationItem>[]
): Promise<ApiResponse<LevelConfigurationItem[]>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.LEVELS_CONFIGURATIONS}`,
      HttpMethods.PATCH,
      levelConfigurations,
      getHeaderFromSessionStorage(Header.FACILITY_ID)
   )
   return response
}

export async function requestDeleteLevelConfiguration(
   levelConfigurationId: string
): Promise<ApiResponse<void>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.LEVELS_CONFIGURATIONS}${levelConfigurationId}/`,
      HttpMethods.DELETE,
      null,
      getHeaderFromSessionStorage(Header.FACILITY_ID)
   )
   return response
}
